import { jsx as _jsx } from "react/jsx-runtime";
import { CodeListing, Prose } from '@criteria-labs/react-typography';
import { contentForResponse } from './contentForResponse';
import { exampleForMediaType } from './exampleForMediaType';
export function ResponseFigure({ endpoint }) {
    const responseWithStatusCode = endpoint.mainSuccessResponse();
    if (!responseWithStatusCode) {
        return null;
    }
    const [statusCode, response] = responseWithStatusCode;
    const [mainContentType, mainContent] = contentForResponse(response);
    if (!mainContent) {
        return null;
    }
    const example = exampleForMediaType(mainContent);
    const code = JSON.stringify(example, null, '  ');
    return (_jsx(Prose, { className: "max-w-none", children: _jsx(CodeListing, { title: "Response", code: code, language: "json", className: "mt-6" }) }));
}
